var FormulaireInscription = {
    txt_participant:"",
    init:function(){

        FormulaireInscription.txt_participant = $(".participants-container").html();

        $(".participant-number").on("change", function(){
            FormulaireInscription.update_participant_number();
        })
        $(".number-interaction .btn-minus").on("click touchend", function(e){
            if(e.type == "touchend"){
                $(this).off("click");
            }
            var _val =  parseInt($(".participant-number").val());
            var _next_val = parseInt(_val - 1).toString();

            if(_val > 1){
                $(".participant-number").val(_next_val);
                FormulaireInscription.update_participant_number();
            }
        })
        $(".number-interaction .btn-plus").on("click touchend", function(e){
            if(e.type == "touchend"){
                $(this).off("click");
            }
            var _val =  parseInt($(".participant-number").val());
            var _next_val = parseInt(_val + 1).toString();

            $(".participant-number").val(_next_val);
            FormulaireInscription.update_participant_number();

        })

        $(".radio-info-participant input[type='checkbox']").on("change", function() {
            if($(this).prop("checked") == true){
                $(".participants-container").addClass("visible");
            }else{
                $(".participants-container").removeClass("visible");
            }

        });
    },
    update_participant_number:function(){
        var _val =  parseInt($(".participant-number").val());
        var _val_with_zero = parseInt(_val).toString();
        var total = _val*$('.inscription-cart-resume-container').data('price');
        $(".inscription-cart-resume-container .participant-number .number").html(_val);
        $('.input-nb-participants').val(_val);
        $("input.participant-number").val(_val_with_zero);
        $('.prix-total').find('.prix').find('.number.total').html(total);
        console.log(total);
        console.log("CHANGE PARTICIPANT NUMBER : " + _val);
        $(".participants-container").html("");
        for (var i = 1; i <= _val; i++){

            var _next_participant = FormulaireInscription.txt_participant.split('<span class="number">1</span>').join('<span class="number">' + i +'</span>');

            _next_participant = _next_participant.split("-participant-1").join("-participant-" + i);

            $(".participants-container").append(_next_participant);
        }

        Label_Anime.init();
    }

}

$(window).load(function(){
    if($(".page-template-formulaire_inscription").length){
        FormulaireInscription.init();
    }
    if($('.inscription-card').length){

        $('.select_dates').on("change", function(event){
            var link = new URL($('.inscription-card').find('button').find('.link').attr('href'));
            link.searchParams.set('formation_id', $(this).val());
            console.log(link.toString());
            $('.inscription-card').find('button').find('.link').attr('href', link.toString());
            $('.formation-infos').addClass('hide');
            $('.formation-'+$(this).val()).removeClass('hide');
        });
    }
})